(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .factory('ModuleConfig', ModuleConfig)
      .factory('TabConfig', TabConfig)
      .factory('PageConfig', PageConfig)
      .factory('SectionConfig', SectionConfig)
      .factory('CalloutLabelService', CalloutLabelService)
      .factory('Section', SectionClass)
      .factory('Chart', ChartClass)
      .factory('SeriesService', SeriesService);


  function ModuleConfig() {
    var standardReports = Module("standard.reports", "standard-report");
    return {
      standardReports: standardReports
    }
  }

  function TabConfig(ModuleConfig) {

    return {
      transaction:  Tab("transactions", ModuleConfig.standardReports, "Transaction"),
      shoppers: Tab("shoppers", ModuleConfig.standardReports, "Shoppers"),
      executiveSummary: Tab("executiveSummary", ModuleConfig.standardReports, "Executive Summary", "executive-summary"),
      comparisons: Tab("comparisons", ModuleConfig.standardReports, "Comparisons")
    }
  }

  function PageConfig(TabConfig, ExportType){
    var defaultExportTypes = [ExportType.csv, ExportType.pdf];

    return {
      transactionSummary: Page("summary", TabConfig.transaction, "Summary", defaultExportTypes),
      orders: Page("orders", TabConfig.transaction, "Orders", defaultExportTypes),
      revenue: Page("revenue", TabConfig.transaction, "Revenue", defaultExportTypes),
      shoppersSummary: Page("summary", TabConfig.shoppers, "Summary", defaultExportTypes),
      sessions: Page("sessions", TabConfig.shoppers, "Sessions", defaultExportTypes),
      activeUsers: Page("activeUsers", TabConfig.shoppers, "Active Users", defaultExportTypes,"active-users"),
      adoption: Page("adoption", TabConfig.shoppers, "Adoption", defaultExportTypes),
      kids: Page("kids", TabConfig.shoppers, "Kids", defaultExportTypes,"kids"),
      sfo: Page("sfo", TabConfig.shoppers, "SFO", defaultExportTypes,"sfo"),
      summary: Page("summary", TabConfig.executiveSummary, "Summary", defaultExportTypes),
      orderRate: Page("ordersRate", TabConfig.transaction, "Order Rate", defaultExportTypes,"order-rate"),
      dateRangeComparison: Page("dateRange", TabConfig.comparisons, "Date Range Comparison", defaultExportTypes, "date-range"),
      hierarchyComparison: Page("hierarchy", TabConfig.comparisons, "Hierarchy Comparison", defaultExportTypes),
      shopperProfiles: Page("shopperProfiles", TabConfig.shoppers, "Shopper Profiles",
          [ExportType.excel, ExportType.pdf],"shopper-profiles")
    }
  }

  function SectionConfig(PageConfig, Section, TransactionsConfig, ShoppersConfig, ComparisonsConfig) {

    //TODO make valueType an ENUM
    var mau = ShoppersConfig.mau;
    var totalSessions = ShoppersConfig.totalSessions;
    var totalOrders = TransactionsConfig.totalOrders;
    var sessionForConversion = ShoppersConfig.sessionForConversion;
    var ordersForConversion =  TransactionsConfig.ordersForConversion;
    var mauTF = ShoppersConfig.mauTF;
    var revenue = TransactionsConfig.revenue;


    return {

      execSPU: Section("executiveSPU", PageConfig.summary),
      execConversion: Section("execConversion", PageConfig.summary),
      execAOV: Section("execAOV", PageConfig.summary),
      execUPT: Section("execUPT", PageConfig.summary),
      execARPU: Section("execARPU", PageConfig.summary),


      // Sections
      sessions : TransactionsConfig.sessions(totalSessions),
      orders : TransactionsConfig.orders(totalOrders),
      conversion : TransactionsConfig.conversion,

      ordersForConversion: ordersForConversion,
      totalOrders: totalOrders,
      tfOrders: TransactionsConfig.tfOrders,
      nonTFOrders: TransactionsConfig.nonTFOrders,

      revenue: revenue,
      // incrRevenue: Section("incrRevenue", PageConfig.revenue),
      aov: TransactionsConfig.aov,
      rps: TransactionsConfig.rps,
      arpu: TransactionsConfig.arpu,
      mrps: TransactionsConfig.mrps,
      upt: TransactionsConfig.upt,
      units: TransactionsConfig.units,

      monthlyOrders : TransactionsConfig.monthlyOrders(ordersForConversion),
      monthlyUsers : TransactionsConfig.monthlyUsers(mau),
      ordersPerUser : TransactionsConfig.ordersPerUser,

      spu : ShoppersConfig.spu,
      mauSummary : ShoppersConfig.mauSummary(mau),
      monthlySessions : ShoppersConfig.monthlySessions(sessionForConversion),

      sessionForConversion : sessionForConversion,
      totalSessions : totalSessions,
      tfSessions : ShoppersConfig.tfSessions,
      nonTFSessions : ShoppersConfig.nonTFSessions,

      mau: mau,
      mauTF: mauTF,
      dau: ShoppersConfig.dau,
      dauTF: ShoppersConfig.dauTF,
      newUsers: ShoppersConfig.newUsers,

      adoption: ShoppersConfig.adoption(mau),
      tfReg: ShoppersConfig.tfReg(mauTF),
      tfSessionsAdoption: ShoppersConfig.tfSessionsAdoption(totalSessions),
      tfOrdersAdoption: ShoppersConfig.tfOrdersAdoption(totalOrders),
      tfRevenue: ShoppersConfig.tfRevenue(revenue),

      kidsMauTF: ShoppersConfig.kidsMauTF,
      kidsDauTF: ShoppersConfig.kidsDauTF,
      newKidsProfiles: ShoppersConfig.newKidsProfiles,
      tfUsersWithNewKids: ShoppersConfig.tfUsersWithNewKids,
      allTimeKidsProfiles: ShoppersConfig.allTimeKidsProfiles,
      allTimeUserWithKidsProfiles: ShoppersConfig.allTimeUserWithKidsProfiles,

      sfoMauTF: ShoppersConfig.sfoMauTF,
      sfoDauTF: ShoppersConfig.sfoDauTF,
      newSFOProfiles: ShoppersConfig.newSFOProfiles,
      tfUsersWithNewSFO: ShoppersConfig.tfUsersWithNewSFO,
      allTimeSFOProfiles: ShoppersConfig.allTimeSFOProfiles,
      allTimeUserWithSFOProfiles: ShoppersConfig.allTimeUserWithSFOProfiles,

      ageProfiles: ShoppersConfig.ageProfiles,
      heightProfiles: ShoppersConfig.heightProfiles,
      weightProfiles: ShoppersConfig.weightProfiles,
      inseamProfiles: ShoppersConfig.inseamProfiles,
      footLengthProfiles: ShoppersConfig.footLengthProfiles,
      bustSizeProfiles: ShoppersConfig.bustSizeProfiles,

      torsoLengthProfiles: ShoppersConfig.torsoLengthProfiles,
      stomachShapeProfiles: ShoppersConfig.stomachShapeProfiles,
      hipShapeProfiles: ShoppersConfig.hipShapeProfiles,
      thighShapeProfiles: ShoppersConfig.thighShapeProfiles,
      archShapeProfiles: ShoppersConfig.archShapeProfiles,
      calfShapeProfiles: ShoppersConfig.calfShapeProfiles,
      breastShapeProfiles: ShoppersConfig.breastShapeProfiles,
      buildProfiles: ShoppersConfig.buildProfiles,
      seatShapeProfiles: ShoppersConfig.seatShapeProfiles,

      ordersDateRangeComparison: ComparisonsConfig.orders(PageConfig.dateRangeComparison),
      sessionsDateRangeComparison: ComparisonsConfig.sessions(PageConfig.dateRangeComparison),
      revenueDateRangeComparison: ComparisonsConfig.revenue(PageConfig.dateRangeComparison),
      mauDateRangeComparison: ComparisonsConfig.mau(PageConfig.dateRangeComparison),
      dauDateRangeComparison: ComparisonsConfig.dau(PageConfig.dateRangeComparison),
      conversionDateRangeComparison: ComparisonsConfig.conversion(PageConfig.dateRangeComparison),
      spuDateRangeComparison: ComparisonsConfig.spu(PageConfig.dateRangeComparison),
      adoptionDateRangeComparison: ComparisonsConfig.adoption(PageConfig.dateRangeComparison),
      newUsersDateRangeComparison: ComparisonsConfig.newUsers(PageConfig.dateRangeComparison),

      ordersHierarchyComparison: ComparisonsConfig.orders(PageConfig.hierarchyComparison),
      sessionsHierarchyComparison: ComparisonsConfig.sessions(PageConfig.hierarchyComparison),
      revenueHierarchyComparison: ComparisonsConfig.revenue(PageConfig.hierarchyComparison),
      mauHierarchyComparison: ComparisonsConfig.mau(PageConfig.hierarchyComparison),
      dauHierarchyComparison: ComparisonsConfig.dau(PageConfig.hierarchyComparison),
      conversionHierarchyComparison: ComparisonsConfig.conversion(PageConfig.hierarchyComparison),
      spuHierarchyComparison: ComparisonsConfig.spu(PageConfig.hierarchyComparison),
      adoptionHierarchyComparison: ComparisonsConfig.adoption(PageConfig.hierarchyComparison),
      newUsersHierarchyComparison: ComparisonsConfig.newUsers(PageConfig.hierarchyComparison)
    }

  }

  function CalloutLabelService(UserCohort, ConsumerChartDisplay) {

    var labelCache = {};

    function key(calloutSection, labelName) {
      return calloutSection.key + "." + labelName;
    }

    function cache(calloutSection, labelName, calloutLabel) {
      if(!calloutLabel){
        return labelCache[key(calloutSection, labelName)];
      } else {
        labelCache[key(calloutSection, labelName)] = calloutLabel;
        return calloutLabel;
      }
    }

    function createCalloutLabel(name, color, overrideLabelProp, userCohort){
      return function (showPercent, overrideUserCohort, overrideColor) {
        return function (section) {
          var calloutSection = section.callout;
          // create only if not already created
          if(cache(calloutSection, name)){
            return cache(calloutSection, name);
          } else {
            return cache(
                calloutSection,
                name,
                CalloutLabel(
                    name,
                    overrideColor || color,
                    calloutSection,
                    overrideLabelProp,
                    overrideUserCohort || userCohort,
                    showPercent
                )
            );
          }
        };
      };
    }

    return {
      tf: createCalloutLabel('tf', ConsumerChartDisplay.Colors.tfLine, 'standard.reports.tf', UserCohort.tf),
      nonTF: createCalloutLabel('nonTF', ConsumerChartDisplay.Colors.nonTFLine,'standard.reports.nontf', UserCohort.nonTF),
      sitewide: createCalloutLabel('sitewide', ConsumerChartDisplay.Colors.totalLine, 'standard.reports.sitewide', UserCohort.all),
      sitewideWithBots: createCalloutLabel('sitewideWithBots', ConsumerChartDisplay.Colors.totalLine, 'standard.reports.sitewide.with.bots', UserCohort.all),
      total: createCalloutLabel('total', ConsumerChartDisplay.Colors.tfLine, 'standard.reports.total'),
      sectionTotal: createCalloutLabel('total', ConsumerChartDisplay.Colors.tfLine),
      tfRegistered: createCalloutLabel('tfRegistered', ConsumerChartDisplay.Colors.registered),
      siteRegistered: createCalloutLabel('siteRegistered', ConsumerChartDisplay.Colors.siteRegistered, 'standard.reports.siteregistered'),
      travellingRegistered: createCalloutLabel('travellingRegistered', ConsumerChartDisplay.Colors.travellingRegistered, 'standard.reports.travelling'),
      ipRegistered: createCalloutLabel('ipRegistered', ConsumerChartDisplay.Colors.ipRegistered, 'standard.reports.instant.profile'),
      tfPercent: createCalloutLabel('tfPercent', ConsumerChartDisplay.Colors.tfLine, null, UserCohort.tf),
      usedForReporting: createCalloutLabel("usedForReporting", ConsumerChartDisplay.Colors.tfLine),
      change: createCalloutLabel("change", ConsumerChartDisplay.Colors.tfLine, null, UserCohort.tf),
      lift: createCalloutLabel("lift", ConsumerChartDisplay.Colors.tfLine, null, UserCohort.tf),
      //  todo - Find a better way of handling these labels which are similar to tfRegistered
      tfUsersWithRecipient: createCalloutLabel("tfUsersWithRecipient", ConsumerChartDisplay.Colors.registered),
      tfUsersWithRecipientSite: createCalloutLabel("tfUsersWithRecipientSite", ConsumerChartDisplay.Colors.siteRegistered),
      tfUsersWithRecipientTravelling: createCalloutLabel("tfUsersWithRecipientTravelling", ConsumerChartDisplay.Colors.travellingRegistered),
      tfProfiles: createCalloutLabel("tfProfiles", ConsumerChartDisplay.Colors.registered),
      tfProfilesSite: createCalloutLabel("tfProfilesSite", ConsumerChartDisplay.Colors.siteRegistered),
      tfProfilesTravelling: createCalloutLabel("tfProfilesTravelling", ConsumerChartDisplay.Colors.travellingRegistered)
    };
  }

  function SeriesService(UserCohort, ConsumerChartDisplay) {

    var labelCache = {};

    function key(calloutSection, labelName) {
      return calloutSection.key + "." + labelName;
    }

    function cache(calloutSection, labelName, calloutLabel) {
      if(!calloutLabel){
        return labelCache[key(calloutSection, labelName)];
      } else {
        labelCache[key(calloutSection, labelName)] = calloutLabel;
        return calloutLabel;
      }
    }

    function createSeries(name, color, overrideLabelProp, userCohort){
      return function (filter, overrideUserCohort, overrideColor, stackedTotal) {
        return function (section) {
          var calloutSection = section.chart;
          // create only if not already created
          if(cache(calloutSection, name)){
            return cache(calloutSection, name);
          } else {
            return cache(
                calloutSection,
                name,
                Series(
                    name,
                    overrideColor || color,
                    calloutSection,
                    overrideLabelProp,
                    overrideUserCohort || userCohort,
                    filter,
                    stackedTotal
                )
            );
          }
        };
      };
    }

    return {
      tf: createSeries('tf', ConsumerChartDisplay.Colors.tfLine, 'standard.reports.tf', UserCohort.tf),
      tfWithBots: createSeries('tfWithBots', ConsumerChartDisplay.Colors.totalLine, 'standard.reports.tf.with.bots', UserCohort.tf),
      nonTF: createSeries('nonTF', ConsumerChartDisplay.Colors.nonTFLine,'standard.reports.nontf', UserCohort.nonTF),
      nonTFWithBots: createSeries('nonTFWithBots', ConsumerChartDisplay.Colors.totalLine,'standard.reports.nontf.with.bots', UserCohort.nonTF),
      sitewide: createSeries('sitewide', ConsumerChartDisplay.Colors.totalLine, 'standard.reports.sitewide', UserCohort.all),
      sitewideWithBots: createSeries('sitewideWithBots', ConsumerChartDisplay.Colors.totalLine, 'standard.reports.sitewide.with.bots', UserCohort.all),
      tfRegistered: createSeries('tfRegistered', ConsumerChartDisplay.Colors.registered, 'standard.reports.registered'),
      siteRegistered: createSeries('siteRegistered', ConsumerChartDisplay.Colors.siteRegistered, 'standard.reports.siteregistered'),
      travellingRegistered: createSeries('travellingRegistered', ConsumerChartDisplay.Colors.travellingRegistered, 'standard.reports.travelling'),
      ipRegistered: createSeries('ipRegistered', ConsumerChartDisplay.Colors.ipRegistered, 'standard.reports.instant.profile'),
      tfUsersWithRecipient: createSeries("tfUsersWithRecipient", ConsumerChartDisplay.Colors.registered),
      tfUsersWithRecipientSite: createSeries("tfUsersWithRecipientSite", ConsumerChartDisplay.Colors.siteRegistered),
      tfUsersWithRecipientTravelling: createSeries("tfUsersWithRecipientTravelling", ConsumerChartDisplay.Colors.travellingRegistered),
      tfProfiles: createSeries("tfProfiles", ConsumerChartDisplay.Colors.registered),
      tfProfilesSite: createSeries("tfProfilesSite", ConsumerChartDisplay.Colors.siteRegistered),
      tfProfilesTravelling: createSeries("tfProfilesTravelling", ConsumerChartDisplay.Colors.travellingRegistered)
    };
  }

  var parentObj = {
    get: function (childName, type) {
      var mapKey = this._mapKey(child, type);
      return this.children[mapKey];
    },
    _add: function (child, type) {
      var mapKey = this._mapKey(child, type);
      if(this[mapKey]){
        throw new Error("Same property is already defined. Try using some other name for child " + mapKey);
      }
      this[mapKey] = child;
      this.children.push(child);
      return this;
    },
    _initialize: function (name, parent, keySuffix) {
      this.name = name;
      this.key = (parent ? parent.key + "." + name : name) + (keySuffix ? "." + keySuffix: "");
      this.children = [];
      this.parent = parent;
      parent && parent._add(this);

    },
    _mapKey: function (child, type) {
      return type ? type + "_" + child.name : child.name;
    },
    _setApiPrefix: function (parentURI, uri) {
      this.apiPrefix = (parentURI ? parentURI + '/' : '') + (uri ? uri : this.name);
    }
  };

  _.extend(Module.prototype, parentObj);
  _.extend(Tab.prototype, parentObj);
  _.extend(Page.prototype, parentObj);
  _.extend(Callout.prototype, parentObj);
  _.extend(CalloutLabel.prototype, parentObj);
  _.extend(Series.prototype, parentObj);



  function Module(name){
    if (!(this instanceof Module)) return new Module(name);
    this._initialize(name);
  }

  function Tab(name, module, displayName, uriPrefix){
    if (!(this instanceof Tab)) return new Tab(name, module, displayName, uriPrefix);
    this._initialize(name, module);
    this._setApiPrefix('', uriPrefix);
    this.displayName = displayName;
  }

  function Page(name, tab, displayName, exportTypes, uriPrefix) {
    if (!(this instanceof Page)) return new Page(name, tab, displayName, exportTypes, uriPrefix);
    this._initialize(name, tab);
    this._setApiPrefix(tab.apiPrefix, uriPrefix);
    this.exportUrl = this.apiPrefix + '/export/daily';
    this.stateName = tab.name + '.' + name;
    this.displayName = tab.displayName + " - " + displayName;
    this.exportTypes = exportTypes;
  }

  function SectionClass() {
    function Section(name, page, chart, callouts, options) {
      if (!(this instanceof Section)) return new Section(name, page, chart, callouts, options);
      this._initialize(name, page);

      Callout(this, callouts);
      chart && chart(this);
      this.chart && this.chart.viewDetailSection && (this.viewDetailState = this._viewDetailState(this.chart.viewDetailSection));
      _.extend(this, options);
    }

    _.extend(Section.prototype, parentObj, {
      _viewDetailState: function (viewDetailSection) {
        var pageState = viewDetailSection.parent.stateName;
        return pageState + "({ '#' : '" + viewDetailSection.name + "'})";
      }
    });

    return Section;
  }

  function Callout(section, callouts) {
    if (!(this instanceof Callout)) return new Callout(section, callouts);
    this._initialize("callout", section);

    var that = this;
    that.values = _.map(callouts, function (callout) {
      var obj = {};
      obj.title = !callout.hideTitle && that.key + ".title";
      obj.summaryKey = callout.summaryKey;
      obj.values = _.map(callout.values, function (value) {
        return value(section)
      });
      return obj;
    });
  }

  function ChartClass() {
    function Chart(name, chartType, valueType, viewDetailSection, series) {
      if (!(this instanceof Chart)) return new Chart(name, chartType, valueType, viewDetailSection, series);

      var that = this;
      that.name = name;
      that.chartType = chartType;
      that.valueType = valueType;
      that.viewDetailSection = viewDetailSection;

      return function (section) {
        that._initialize("chart", section);
        that.label = that.key + ".label";
        that.tooltip = that.key + ".tooltip";
        that.yAxisLabel =  that.key + ".yAxisLabel";
        that.series = _.map(series, function (line) {
          return line(section);
        });
      }
    }
    _.extend(Chart.prototype, parentObj);

    return Chart;
  }

  function CalloutLabel(name, color, calloutSection, overrideLabelProp, userCohort, showPercent) {
    if (!(this instanceof CalloutLabel))
      return new CalloutLabel(name, color, calloutSection, overrideLabelProp, userCohort, showPercent);

    var that = this;
    that._initialize(name, calloutSection);

    that.attributeName = this.name;
    that.label = overrideLabelProp || this.key + ".label";
    that.tooltip = this.key + ".tooltip";
    that.userCohort = userCohort;
    that.color = color.stroke;
    that.colorClass = color.class;
    that.showPercent = showPercent;
  }

  function Series(name, color, chartSection, overrideLabelProp, userCohort, filter, stackedTotal) {
    if (!(this instanceof Series))
      return new Series(name, color, chartSection, overrideLabelProp, userCohort, filter, stackedTotal);

    var that = this;
    that._initialize(name, chartSection);

    that.attributeName = this.name;
    that.label = overrideLabelProp || this.key + ".label";
    that.userCohort = userCohort;
    that.color = color;
    that.filter = filter;
    that.stackedTotal = stackedTotal;
  }

})();